import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import TextareaAutosize from 'react-textarea-autosize';
import s from './CreateBook.module.css';
import {Form} from 'react-bootstrap';
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';
import {ItemConstant, ItemObjectList} from '../middleware/MyConstant';

export default function CreateBook(prop) {	
	const navigate = useNavigate();
	const fetchList = prop.updateData;
	
	let defaultToggle = getGeneralStorage('createBookToggle') ?? 70;
	
	let tmpString = "Picture 1 - first line\nPicture 1 - second line\nPicture 1 - third line\n\nPicture 2 - first line\nPicture 2 - second line\nPicture 2 - third line\n\n"
	
	const [sentence, setSentence] = useState(tmpString);
	const [name, setName] = useState("");
	const [longName, setLongName] = useState("");
	const [theme, setTheme] = useState("");
	const [canConfirm, setCanConfirm] = useState(true);
	
	const [allLabels, setAllLabels] = useState([]);
	
	
	const fetchData = async () => {
		await getData('item/listAllKeyTags', navigate)
		.then(res => {
				setAllLabels(res.data);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);

	const convertSentence = async () => {
		let tmp = sentence.replace(/\n/g, '\n\n');
		tmp = tmp.replace(/\t/g, '\n');
		setSentence(tmp);
		
	}
	
const breakSentence = (s) => {
    // 修改点1：优先处理「引号包裹句末标点」场景（"xxx!"、"xxx?"、"xxx."）
    let tmp = s.replace(/"([^"]+)([.!?])"(?!\n)/g, (match, content, p1) => {
        // 拼接为 "xxx!"\n，实现整体后换行
        return `"${content}${p1}"\n`;
    })
    // 修改点2：再处理「单独句末标点」场景（无引号包裹的 . ! ?）
    .replace(/([.!?])(?!\n|")/g, (match, p1) => {
        // 排除后续紧跟引号的情况（避免和上面的场景重复处理）
        switch (p1) {
            case '.':
                return '.\n';
            case '!':
                return '!\n';
            case '?':
                return '?\n';
        }
    })
    // 保留原有空格清理逻辑
    .replace(/\n +/g, '\n');

    const honorifics = ["Mr", "Mrs", "Ms", "Miss", "Dr", "Prof"];
    let actTmp = "";

    for (let i = 0; i < tmp.length; i++) {
        // 保持简化的双引号处理（原样拼接，不丢失字符）
        actTmp += tmp[i];

        // 保留敬称修正逻辑
        if (tmp[i] === '.') {
            let honorificIndex = -1;
            for (let j = i - 1; j >= 0; j--) {
                if (tmp[j] === ' ' || tmp[j] === '\n') {
                    break;
                }
                honorificIndex = j;
            }

            if (honorificIndex !== -1) {
                const potentialHonorific = tmp.substring(honorificIndex, i);
                if (honorifics.includes(potentialHonorific)) {
                    // 移除手动 i++，避免潜在的字符跳过问题
                    actTmp = actTmp.slice(0, -1); // 删掉误加的换行
                    actTmp += ". "; // 还原敬称后的句点+空格
                    continue;
                }
            }
        }
    }

    return actTmp;
}


	const [englishOnly, setEnglishOnly] = useState([]); 
	const [enZhMap, setEnZhMap] = useState(new Map());

	const processENHKSentence = (text) => {
		const lines = text.split('\n').filter(line => line.trim() !== '');

		const tempEnglish = [];
		const tempMap = new Map();

		for (let i = 0; i < lines.length; i += 2) {
			const english = lines[i]?.trim();
			const chinese = lines[i + 1]?.trim();

			if (english && chinese) {
				tempEnglish.push(english);
				tempMap.set(english, chinese);
			}
		}

		setEnglishOnly(tempEnglish);
		setEnZhMap(tempMap);

		
	};

	const createItem = async () => {
		const tempEnCnMap = new Map();
		let tmpSentence = sentence;
		if (contentMode === "enhk") {
			const lines = sentence.split('\n'); 

			const tempEnglish = [];

			let i = 0;
			while (i < lines.length) {
				const currentLine = lines[i].trim();
				const rawLine = lines[i]; // Keep original empty line for tempEnglish

				// CASE 1: Empty line → push to tempEnglish ONLY, skip mapping
				if (currentLine === '') {
					tempEnglish.push(rawLine);
					i++; // Move to next line
				} 
				// CASE 2: Non-empty line → treat as English, pair with next line (Chinese)
				else {
					const english = currentLine;
					const chinese = lines[i + 1]?.trim() || '';

					// Add English to array + add to mapping
					tempEnglish.push(english);
					if (chinese) {
						tempEnCnMap.set(english, chinese);
					}

					i += 2; // Skip the Chinese line (do NOT add to tempEnglish)
				}
			}

			tmpSentence = tempEnglish.join('\n');
		}

		if (!canConfirm) {
			return;
		}
		
		setCanConfirm(false);
		
		
		let partAArray = [];
		for (const p of sPartA) {
			partAArray.push({type:"a",msg:p,msgJson:{hk:""}, soundTrack:null});
		}
		
		let partBArray = [];
		for (const p of sPartB) {
			partBArray.push({type:"b",msg:p,msgJson:{hk:""}, soundTrack:null});
		}
		
		let obj = {
			'name' : name,
			'sentence' : tmpSentence,
			'tempEnCnMap' : Object.fromEntries(tempEnCnMap),
			
			'longName' : longName,
			'theme' : theme,
			
			'rTheme' : rTheme,
			'rSkill' : rSkill,
			'rType' : rType,
			'rLength' : readType,
			'rCode' : rCode,
			'rDifficulty' : rDifficulty,
			'rRelationship' : rRelationship,
			'rTextType' : rTextType,
			
			'sTopic': sTopic,
			'sMainMsg': sMainMsg,
			'sPartA': partAArray,
			'sPartB': partBArray,
		}
		
		obj['itemType'] = toggle;
		/*
		switch(toggle) {
			case 1: obj['itemType'] = 70; break;
			case 2: obj['itemType'] = 72; break;
			case 3: obj['itemType'] = 73; break;
			case 4: obj['itemType'] = 74; break;
			case 5: obj['itemType'] = 75; break;
			case 6: obj['itemType'] = 76; break;
			case 7: obj['itemType'] = 77; break;
			case 8: obj['itemType'] = 78; break;
			case 9: obj['itemType'] = 79; break;
			case 10: obj['itemType'] = 80; break;
			case 11: obj['itemType'] = 81; break;
			case 12: obj['itemType'] = 82; break;
			case 13: obj['itemType'] = 83; break;
			case 14: obj['itemType'] = 87; break;
			case 15: obj['itemType'] = 88; break;
		}*/
		
		await postData("item/createItem", obj, navigate); 
		setSentence(tmpString);
		setName('');
		
		setLongName('');
		setTheme('');
		
		setKeySetting('');
		setRCode('');
		setRDifficulty('');
		setRTextType('');
		setRRelationship('');
		setSpeakingQuick('');
		setRTheme([]);
		setRSkill([]);
		setRType([]);
		
		setEnglishOnly([]);
		setEnZhMap(new Map());

		setSTopic("");
		setSMainMsg("");
		setSPartA([]);
		setSPartB([]);
		
		fetchList();
		
		setTimeout(() => {
      setCanConfirm(true);
    }, 5000);
	}
	
	const getWidth = (myText) => {
		let width = myText.length * 15;
		return {width:width + "px"};
  };
	
	
	const [toggle, setToggle] = useState(parseInt(defaultToggle));
	const [readType, setReadType] = useState("excerpt");
	const [keySetting, setKeySetting] = useState("");
	const [speakingQuick, setSpeakingQuick] = useState("main message\n(A)\nst\nnd\nrd\n(B)\naa\nbb\ncc");
	const [rCode, setRCode] = useState("");
	const [rRelationship, setRRelationship] = useState("");
	const [rDifficulty, setRDifficulty] = useState("");
	const [rTextType, setRTextType] = useState("");
	const [rTheme, setRTheme] = useState([]);
	const [rSkill, setRSkill] = useState([]);
	const [rType, setRType] = useState([]);
	
	
	const [sTopic, setSTopic] = useState("");
	const [sMainMsg, setSMainMsg] = useState("main message");
	const [sPartA, setSPartA] = useState(["st","nd","rd"]);
	const [sPartB, setSPartB] = useState(["aa","bb","cc"]);
	

	const [contentMode, setContentMode] = useState("default");
	const toggleContentMode = () => {
		setContentMode(prevMode => prevMode === "default" ? "enhk" : "default");
}	;

	const ItemToggleUL = ({itemType, name}) => {
		return <ul className={(toggle == itemType) ? s.toggleOptionOn : ""} onClick={()=>{setGeneralStorage('createBookToggle', itemType);setToggle(itemType);}}>{name}</ul>
	}
	
	const CommonTextValue = ({myKey, myValue}) => {
		return (<div style={{display:"flex", borderBottom:"1px solid #22222222"}}>
							<div style={{width:"150px"}}>{myKey}</div>
							<div>{myValue}</div>
						</div>);
	}
	
	return (<div>
		<div  style={{borderBottom:"1px solid #ABABAB", padding:"10px"}}>
			
			<div style={{display:"flex",flexDirection:"column",alignItems:"start"}}>
				<li className={s.toggleOptionHolder} style={{margin:"2px"}}>
					{ItemObjectList.map((io, indexIO)=>(
						<ItemToggleUL key={indexIO} itemType={io.itemType} name={io.name} />
					
					))}
				</li>
			</div>
		</div>
		<div className={s.nameInput} style={{marginTop:"5px", marginBottom:"5px"}}>
			<div>
				<div style={{marginRight:"5px"}}><span>Name</span></div>
				<div>
					<Form.Control value={name}
						onChange={e => setName(e.target.value)} 
						aria-describedby="basic-addon1"
					/>
				</div>
			</div>
		</div>
		<div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
			{/*
				([3].includes(toggle)) && (<>
							
					<div>
						<ul className={s.toggleLitOptionHolder}>
							<li style={getWidth("excerpt")} className={(readType == "excerpt") ? s.toggleLitOptionOn : s.toggleLitOptionOff} onClick={()=>{setReadType("excerpt");}}>Excerpt</li>
							<li style={getWidth("full")} className={(readType == "full") ? s.toggleLitOptionOn : s.toggleLitOptionOff} onClick={()=>{setReadType("full");}}>Full</li>
							
						</ul>
					</div>
				</>)*/
			}
			
			{
				(ItemConstant.BasicCreateShortCutIts.includes(toggle)) && (<div style={{display:"flex", width:"90%", flexWrap: "wrap", justifyContent:"center"}}>
					{ (ItemConstant.ReadingIts.includes(toggle)) &&
						(<div style={{border:"1px solid #22222222", width:"100%", margin:"0 10px 10px 10px"}}>
							<div style={{fontWeight:"bold"}}>Theme and Type</div>
							<textarea style={{border:"1px solid #22222222", width:"80%"}} className={s.textAreaAuto} value={keySetting} rows={10} wrap='off' onChange={(e) => {
								let tmp = e.target.value;
								setKeySetting(e.target.value);
								const str = tmp.split(/[\n\t/]/);
								
								let title=""; 
								let theme=[]; 
								let skill=[]; 
								let type=[];
								
								
								let cKey = "";
								let cLine = 0;
								for (let s of str) {
									cLine++;
									if (cLine == 1) {
										setRCode(s);
									}
									s = s.trim();
									if (s == 'DSE Reading' ||
										s == 'Theme' ||
										s == 'Label (skill)' ||
										s == 'Label (type)' ||
										s == 'Difficulty' ||
										s == 'Text type' ||
										s == 'Relationship' ||
										s == 'Time limit') {
										cKey = s;
										continue;
									}
									
									if (s.trim() == '') {
										continue;
									}
									
									switch (cKey) {
										case 'DSE Reading':
											title = s.trim();
											setName(title);
											break;
										case 'Theme':
											theme = [...theme, ...(s.split('//').map(i => i.trim()))];
											break;
										case 'Label (skill)':
											skill = [...skill, ...(s.split('//').map(i => i.trim()))];
											break;
										case 'Label (type)':
											type = [...type, ...(s.split('//').map(i => i.trim()))];
											break;
										case 'Difficulty':
										
											setRDifficulty(s.trim());
											break;
										case 'Relationship':
											setRRelationship(s.trim());
											break;
										case 'Text type':
										
											setRTextType(s.trim());
											break;
										default:
											break;
									}
									
								}		
								theme = theme.filter((t)=>allLabels.includes(t));
								skill = skill.filter((t)=>allLabels.includes(t));
								type = type.filter((t)=>allLabels.includes(t));
								setRTheme(theme);
								setRSkill(skill);
								setRType(type);
							}}/>
						
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Code</div>
								<div style={{textAlign:"left"}}>{rCode}
								</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Difficulty</div>
								<div style={{textAlign:"left"}}>{rDifficulty}
								</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Text type</div>
								<div style={{textAlign:"left"}}>{rTextType}
								</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Theme</div>
								<div style={{textAlign:"left"}}>{
										rTheme.map((t, tIndex)=>(<div>{t}</div>))
									}
								</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Label (skill)</div>
								<div style={{textAlign:"left"}}>{
									rSkill.map((t, tIndex)=>(<div>{t}</div>))
								}</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", textAlign:"left"}}>Label (type)</div>
								<div style={{textAlign:"left"}}>{
									rType.map((t, tIndex)=>(<div>{t}</div>))
								}</div>
							</div>
							<div style={{display:"flex", margin:"20px"}}>
								<div style={{width:"100px", minWidth:"100px", textAlign:"left"}}>Relationship</div>
								<div style={{textAlign:"left"}}>{rRelationship}
								</div>
							</div>
						
						
						</div>)
					}
					
					
					{/*
						([11].includes(toggle)) && (<div>
							<div style={{margin:"10px 0 10px 2px", textAlign:"left"}}>
								<BlueButton isEnabled={true} clickedAction={() => breakSentence()} bText={"Break sentence"} />				
							</div>
								
						</div>)
					*/}
					{ (ItemConstant.SpeakingIts.includes(toggle)) &&
						(<div style={{border:"1px solid #22222222", width:"400px", margin:"5px"}}>
							<div style={{fontWeight:"bold"}}>Speaking Basic</div>
							<textarea style={{border:"1px solid #22222222", width:"80%"}} className={s.textAreaAuto} value={keySetting} rows={10} wrap='off' onChange={(e) => {
								let tmp = e.target.value;
								setKeySetting(e.target.value);
								const str = tmp.split(/[\n\t/]/);
								
								let title=""; 
								let theme=[]; 
								let type=[];
								
								let cKey = "";
								let cLine = 0;
								let cName = "";
								for (let s of str) {
									cLine++;
									if (cLine == 1) {
										setRCode(s);
									}
									s = s.trim();
									if (s == 'DSE Speaking' ||
										s == 'Theme' ||
										s == 'Relationship' ||
										s == 'Difficulty' ||
										s == 'Text type' ||
										s == 'Time limit') {
										cKey = s;
										continue;
									}
									
									if (s.trim() == '') {
										continue;
									}
									
									
									console.log(s);
									switch (cKey) {
										case 'DSE Speaking':
											if (cName == '') {
												cName = s;
												setName(s);
											} else {
												setSTopic(s);
											}
											
											break;
										case 'Theme':
											theme = [...theme, ...(s.split('//').map(i => i.trim()))];
											break;
										case 'Difficulty':
										
											setRDifficulty(s.trim());
											break;
										case 'Relationship':
											setRRelationship(s.trim());
											break;
										case 'Text type':
											setRTextType(s.trim());
											break;
										default:
											break;
									}
								}		
								theme = theme.filter((t)=>allLabels.includes(t));
								type = type.filter((t)=>allLabels.includes(t));
								setRTheme(theme);
								setRType(type);
							}}/>
							
							<div style={{margin:"0 5px", textAlign:"left", fontSize:"18px", borderTop:"1px solid #22222222"}}>
								<CommonTextValue myKey={"Code"} myValue={rCode}/>
								<CommonTextValue myKey="Topic" myValue={sTopic}/>
								<CommonTextValue myKey="Theme" myValue={
											rTheme.map((t, tIndex)=>(<div>{t}</div>))
								}/>
								<CommonTextValue myKey="Difficulty" myValue={rDifficulty}/>
								<CommonTextValue myKey="Text type" myValue={rTextType}/>
								<CommonTextValue myKey="Relationship" myValue={rRelationship}/>
							</div>
					
						</div>)
					}
					
							
					
					<div style={{border:"1px solid #22222222", width:"400px", margin:"5px",

							backgroundColor: contentMode === "enhk" ? "#a2dcf7" : "white",
							transition: "background-color 0.2s ease" // Smooth color transition


					}}>
						{/* ✅ Added toggle button next to the title (visual & clear) */}
						<div style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							alignItems: "center",
							fontWeight:"bold"
						}}>
							<span>Content</span>
							{/* Mode Toggle Button */}
							<button
							onClick={toggleContentMode}
							style={{
								padding: "4px 8px",
								border: "none",
								borderRadius: "4px",
								cursor: "pointer",
								// Highlight button when in 中英 mode
								backgroundColor: contentMode === "enhk" ? "#1890ff" : "#e5e7eb",
								color: contentMode === "enhk" ? "white" : "#333",
							}}
							>
							{contentMode === "enhk" ? "中英模式" : "Default"}
							</button>
						</div>

						{/* ✅ Textarea: DYNAMIC BACKGROUND COLOR for 中英 (enhk) mode */}
						<textarea
							style={{
							border:"1px solid #22222222",
							width:"80%"
							}}
							className={s.textAreaAuto}
							value={sentence}
							rows={10}
							wrap='off'
							onChange={(e) => {
							let v = e.target.value;
							/*if (ItemConstant.VIPWritingIts.includes(toggle)) {
								v = breakSentence(v);
							}*/
							setSentence(v);
							}}
						/>

						{
							(contentMode != "enhk") && (<div>
								<GreenButton
								isEnabled={true}
								clickedAction={() => {setSentence(breakSentence(sentence))}}
								bText={"Break sentence"}
								/>
							</div>)
						}
						{
							(contentMode === "enhk") && (<div>
								<GreenButton
								isEnabled={true}
								clickedAction={() => {processENHKSentence(sentence)}}
								bText={"validate 中/英"}
								/>
							</div>)
						}


						</div>
					
					{
						(ItemConstant.IdeaIts.includes(toggle)) && (<div style={{width:"50%"}}>
						
							<div className={s.paramHolder}>
								<div style={{display:"flex"}}>
									<div style={{display:"flex", padding:"10px 0 0 0"}}>
										<div className={s.nonClickableTitle}>
											<span>Long Name</span>
										</div>
										<div style={{fontWeight:"bold"}}>:</div>		
									</div>
									<div className={s.itemHolder}>
										<input value={longName} onChange={(e)=>{
											setLongName(e.target.value);
										}} />
									</div>
								</div>
								
								<div style={{display:"flex"}}>
									<div style={{display:"flex", padding:"10px 0 0 0"}}>
										<div className={s.nonClickableTitle}>
											<span>Theme</span>
										</div>
										<div style={{fontWeight:"bold"}}>:</div>		
									</div>
									<div className={s.itemHolder}>
										<input value={theme} onChange={(e)=>{
											setTheme(e.target.value);
										}} />
									</div>
								</div>
								<div style={{margin:"10px 0 10px 2px", textAlign:"left"}}>
									<GreenButton isEnabled={canConfirm} clickedAction={() => convertSentence()} bText={"Convert sentence"} />				
								</div>
								
							</div>
						</div>)
					}
					{ (ItemConstant.SpeakingIts.includes(toggle)) &&
						(<div style={{border:"1px solid #22222222", width:"400px", margin:"5px"}}>
							<div style={{fontWeight:"bold"}}>Speaking Detail</div>
							<textarea style={{border:"1px solid #22222222", width:"80%"}} className={s.textAreaAuto} value={speakingQuick} rows={10} wrap='off' onChange={(e) => {
								let tmp = e.target.value;
								setSpeakingQuick(e.target.value);
								
								let {mainMsg, partA, partB} = loadSpeakingQuick(tmp);
								
								setSMainMsg(mainMsg);
								setSPartA(partA);
								setSPartB(partB);
								
								
							}}/>
						
							<div style={{margin:"0 5px", textAlign:"left", fontSize:"18px", borderTop:"1px solid #22222222"}}>
								<CommonTextValue myKey="Content" myValue={sMainMsg}/>
								<CommonTextValue myKey="Part A" myValue={
											sPartA.map((t, tIndex)=>(<div>{t}</div>))
								}/>
								<CommonTextValue myKey="Part B" myValue={
											sPartB.map((t, tIndex)=>(<div>{t}</div>))
								}/>
							</div>
						</div>)
					}
					
					
				</div>)
			}
			
			<div style={{marginBottom:"10px"}}>
				<RedButton isEnabled={canConfirm} clickedAction={() => createItem()} bText={"Confirm?"} />
			</div>
					
			{
				(englishOnly && contentMode === "enhk") && (<div style={{width:"100%"}}>
					{Array.from(enZhMap).map(([english, chinese], index) => (
						<div key={index} style={{margin:"20px 0", textAlign:"left"}}>
						{english} - <span style={{background:"#b9f7ce"}}>{chinese}</span>
						</div>
					))}
				</div>)
			}
		</div>
	</div>)
}


const loadSpeakingQuick = (tmp) => {
	const str = tmp.split(/[\n\t/]/);
								
	let mainMsg = "";
	let partA = [];
	let partB = [];
	
	let cTarget = '';
	for (let s of str) {
		s = s.trim();
		if (s.startsWith("(A)") ||
			s.startsWith("(B)")) {
			cTarget = s;
			continue;
		}
		
		if (s == '') {
			continue;
		}
		
		if (mainMsg == "") {
			mainMsg = s;
			continue;
		}
		
		if (cTarget.startsWith("(A)")) {
			partA.push(s.replace(//g, ""));
			continue;
		}
		
		if (cTarget.startsWith("(B)")) {
			partB.push(s.replace(//g, ""));
			continue;
		}
	}
	
	return {mainMsg, partA, partB}
}